export enum AccountType {
  INDIVIDUAL = "individual",
  BUSINESS = "business",
  AGENCY = "agency",
}
